import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ShoppingBag } from 'lucide-react';

const PaymentCancel = () => (
  <div className="pt-40 pb-40 min-h-screen">
    <div className="max-w-lg mx-auto px-5 text-center card-glass rounded-3xl p-12">
      <div className="h-16 w-16 mx-auto rounded-full border border-[#d4af37]/40 flex items-center justify-center mb-6"><XCircle className="h-8 w-8 text-[#f0d582]" /></div>
      <h1 data-testid="payment-canceled" className="font-cinzel text-3xl text-gold-gradient">Checkout Canceled</h1>
      <p className="font-cormorant text-xl text-[#f5ecd9]/75 mt-3">No worries — your cart is still waiting for you whenever you're ready.</p>
      <Link to="/shop" className="btn-gold inline-flex items-center gap-2 mt-8 rounded-full px-8 py-3.5 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37]"><ShoppingBag className="h-4 w-4" /> Return to Shop</Link>
    </div>
  </div>
);

export default PaymentCancel;
